import { SelectedCategoriesEnum as e } from "./selected-categories-enum.mjs";
//#region src/extensions/special-characters-extension/get-characters-categories-data.ts
var t = (t) => [
	{
		label: t("special_characters.select_text"),
		value: e.Text
	},
	{
		label: t("special_characters.select_currency"),
		value: e.Currency
	},
	{
		label: t("special_characters.select_all"),
		value: e.All
	}
];
//#endregion
export { t as getCharactersCategoriesData };
